import { createFileRoute } from "@tanstack/react-router";
import { GalleryCollectionManager } from "@/components/admin/GalleryCollectionManager";

export const Route = createFileRoute("/_authenticated/admin/beauty-show")({
  component: BeautyShowAdmin,
});

function BeautyShowAdmin() {
  return (
    <GalleryCollectionManager
      collection="beauty-episode"
      title="The Beauty Show — Episodes"
      description='Episodes of "Beauty Through Science". New episodes are added at the top. Drag to reorder, or use Sort by date. The top active episode is shown as the latest episode.'
      uploadBucket="beauty-show"
      showPermalink
      showVideo
    />
  );
}
